import { getLogger } from '@hashnode/file-parsing'
import { GraphQLClient } from 'graphql-request'
import { getUserSessionStore } from '../user/user-store'
import { getSdk } from './generated/graphql'

import config from '../config.json'

// Set environment variables from config
Object.entries(config).forEach(([key, value]) => {
	process.env[key] = process.env[key] || value
})

const GQL_ENDPOINT = process.env.GQL_ENDPOINT
const STELLATE_CLIENT_NAME_HEADER = 'x-graphql-client-name'
const STELLATE_CLIENT_VERSION_HEADER = 'x-graphql-client-version'

const logger = getLogger()

export function getClient(options?: Record<string, string>) {
	if (!GQL_ENDPOINT) {
		throw new Error('GQL_ENDPOINT is not set')
	}

	const sessionData = getUserSessionStore().get('auth')

	if (!sessionData) {
		logger.debug('No session data found')
	}

	const client = new GraphQLClient(GQL_ENDPOINT, {
		headers: {
			...createHeaders({
				...(sessionData?.currentConnection === 'Personal-Access-Token' && {
					pat: sessionData?.sessionSecret,
				}),
			}),
			...(options || {}),
		},
	})
	const sdk = getSdk(client)

	return sdk
}

type CreateHeadersOptions = {
	cookies?: string
	token?: string
	pat?: string
}

export function createHeaders(options?: CreateHeadersOptions) {
	const headers: Record<string, string> = {
		'hn-trace-app': 'cli',
		[STELLATE_CLIENT_NAME_HEADER]: 'cli',
		[STELLATE_CLIENT_VERSION_HEADER]: 'server',
	}

	if (options?.token) {
		headers['x-auth-token'] = options.token
	}

	if (options?.pat) {
		headers['Authorization'] = options.pat
	}

	return headers
}
